export default __webpack_public_path__ + "static/ae-3f71c7af6b499d54ed56e2dbb28df3c1.svg";